import { Observable } from 'rxjs';

import {
	ChannelDeviceSpecificEqContour,
	EqFilterType,
	Response
} from '@shure/shared/angular/data-access/system-api/models';

import { ParametricEqualizerChannel, EqualizerFilter, EqualizerFilterFeatures } from '../models';

export type EqualizerFilterUpdate = Partial<Pick<EqualizerFilterFeatures, 'frequency' | 'gain' | 'qFactor'>>;

export abstract class ParametricEqualizerApiService {
	/**
	 * Get channel supporting peq.
	 */
	public abstract getChannel$(channelId: string): Observable<ParametricEqualizerChannel>;

	/**
	 * Get one of the eq filters on the channel.
	 */
	public abstract getEqFilter$(filterId: string): Observable<EqualizerFilter>;

	/**
	 * Set eq contour.
	 */
	public abstract setEqContour(
		channelId: string,
		deviceEqContour: ChannelDeviceSpecificEqContour
	): Observable<Response<void, string>>;

	/**
	 * Set the eq filter's configuration.
	 */
	public abstract setEqualizerFilterConfiguration(
		filterId: string,
		type: EqFilterType,
		enabled: boolean
	): Observable<Response<void, string>>;

	/**
	 * Set equalizer filters values.
	 */
	public abstract setEqualizerFilterValues(
		filterId: string,
		update: EqualizerFilterUpdate
	): Observable<Response<void, string>>;

	/**
	 * Copy equalizer filter values from source to destination filter
	 */
	public abstract copyEqFilter(
		destFilterId: string,
		sourceFilter: EqualizerFilter
	): Observable<Response<void, string>>;

	public abstract clearPEQ(channel: ParametricEqualizerChannel): Observable<Response<void, string>[]>;
}
